import PropTypes from 'prop-types'

const LoaderWrapper = ({ children }) => (
    <div className="fixed top-0 left-0 z-50 w-full">
        {children}
    </div>
)

const Loader = () => (
    <LoaderWrapper>
        <div className="h-1 bg-blue-500 animate-pulse"></div>
    </LoaderWrapper>
)

LoaderWrapper.propTypes = {
    children: PropTypes.node
}

export default Loader
